import axios from './axios'
import { AltroLink } from '@/../../EshJSLib/models/patient'
import * as model from '@/../../EshJSLib/models/patient';




export async function getOspedaliItalianiLinks() {

    const response = await axios.get(`/api/altroLink/ospedali_italiani`);
    return response.data.data as AltroLink[];
}

export async function getOspedaliEsteriLinks() {

    const response = await axios.get(`/api/altroLink/ospedali_esteri`);
    return response.data.data as AltroLink[];
}

export async function getLineGuidaItalianeLinks() {

    const response = await axios.get(`/api/altroLink/line_guida_italiane`);
    return response.data.data as AltroLink[];
}

export async function getLineGuidaInternazionaleLinks() {

    const response = await axios.get(`/api/altroLink/line_guida_internazionale`);
    return response.data.data as AltroLink[];
}

export async function getRisorveWebItalianeLinks() {

    const response = await axios.get(`/api/altroLink/risorve_web_italiane`);
    return response.data.data as AltroLink[];
}

export async function getRisorveWebInternazionaleLinks() {

    const response = await axios.get(`/api/altroLink/risorve_web_internazionale`);
    return response.data.data as AltroLink[];
}

export async function getRivisteItalianeLinks() {

    const response = await axios.get(`/api/altroLink/riviste_italiane`);
    return response.data.data as AltroLink[];
}

export async function getRivisteInternazionaliLinks() {

    const response = await axios.get(`/api/altroLink/riviste_internazionali`);
    return response.data.data as AltroLink[];
}
